import { Component } from '@angular/core';
import { membersuiteRefundEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Refunds') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiterefund-form',
    templateUrl: './membersuiterefund.form.component.html'
})
export class membersuiteRefundFormComponent extends BaseFormComponent {
    public record!: membersuiteRefundEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

